import Vue from 'vue'
import Router from 'vue-router'
const Login = () => import('../views/login/Login.vue')
const Main = () => import('../views/main/Main.vue')
const homeManagement = () => import('../views/main/Home.vue')
const roleManagement = () => import('../views/sysmanagement/roleManagement.vue')
const menuManagement = () => import('../views/sysmanagement/menuManagement.vue')
const appinfomanagement = () => import('../views/appinfomanagement/appInfoManagement.vue')
const facesetmanagement = () => import('../views/facemanagement/faceSetManagement.vue')
const faceInfoManagement = () => import('../views/facemanagement/faceInfoManagement.vue')
const blacklistManagement = () => import('../views/facemanagement/blacklistManagement.vue')
const visitorManagement = () => import('../views/facemanagement/visitorManagement.vue')
const faceTypeManagement = () => import('../views/facemanagement/faceTypeManagement.vue')
const faceTaskManagement = () => import('../views/facemanagement/faceTaskManagement.vue')
const userManagement = () => import('../views/sysmanagement/userManagement.vue')
const deviceTypeManagement = () => import('../views/devicemanagement/deviceTypeManagement.vue')
const deviceManagement = () => import('../views/devicemanagement/deviceManagement.vue')
const deviceStateManagement = () => import('../views/devicemanagement/deviceStateManagement.vue')
const deviceAttrManagement = () => import('../views/devicemanagement/deviceAttrManagement.vue')
const deviceAttrValManagement = () => import('../views/devicemanagement/deviceAttrValManagement.vue')
const recordManagement = () => import('../views/recordmanagement/recordManagement.vue')
const unidentRecordManagement = () => import('../views/recordmanagement/unidentRecordManagement.vue')
const blackRecordManagement = () => import('../views/recordmanagement/blackRecordManagement.vue')
const visitorRecordManagement = () => import('../views/recordmanagement/visitorRecordManagement.vue')
const deviceLogManagement = () => import('../views/recordmanagement/deviceLogManagement.vue')
const videoManagement = () => import('../views/recordmanagement/videoManagement.vue')

const faceDetect = () => import('../views/demo/faceDetect.vue')
const lessSearch = () => import('../views/demo/lessSearch.vue')
const searchOne = () => import('../views/demo/searchOne.vue')
const regionManagement = () => import('../views/regionmanagement/regionManagement.vue')
const groupManagement = () => import('../views/attendancemanagement/groupManagement.vue')
const ruleManagement = () => import('../views/attendancemanagement/ruleManagement.vue')
const attendanceRecordManagement = () => import('../views/attendancemanagement/recordManagement.vue')
const deviceUpdateManagement = () => import('../views/devicemanagement/deviceUpdateManagement.vue')
const deviceRestartManagement = () => import('../views/devicemanagement/deviceRestartManagement.vue')
const deviceVersionManagement = () => import('../views/deviceVersionmanagement/deviceVersionManagement.vue')
const faceServiceSwitch = () => import('../views/switch/faceServiceSwitchManagement.vue')
const localFaceCardRecord = () => import('../views/recordmanagement/localFaceCardRecordManagement.vue')
const localCardRecord = () => import('../views/recordmanagement/localCardRecordManagement.vue')
const viewData = () => import('../views/show/viewData.vue')
const padScreenData = () => import('../views/show/padScreen.vue')
const newsmanagement = () => import('../views/newsManagement/newsManagement.vue')
const sysParameterConfig = () => import('../views/sysConfig/sysParameterConfig.vue')
const outSysConfig = () => import('../views/outSysConfig/outSysConfig.vue')
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/main',
      name: 'main',
      component: Main,
      children: [
        {
          path: '',
          name: '首页',
          /*component: homeManagement*/
          component: recordManagement
        },
        {
          path: '/roleManagement',
          name: '角色管理',
          component: roleManagement
        },
        {
          path: '/menuManagement',
          name: '菜单管理',
          component: menuManagement
        },
        {
          path: '/appinfomanagement',
          name: '应用信息',
          component: appinfomanagement
        },
        {
          path: '/facesetmanagement',
          name: '脸库信息管理',
          component: facesetmanagement
        },
        {
          path: '/faceInfoManagement',
          name: '人员信息管理',
          component: faceInfoManagement
        },
        {
          path: '/blacklistManagement',
          name: '黑名单维护',
          component: blacklistManagement
        },
        {
          path: '/visitorManagement',
          name: '访客管理',
          component: visitorManagement
        },
        {
          path: '/faceTypeManagement',
          name: '人员类型管理',
          component: faceTypeManagement
        },
        {
          path: '/faceTaskManagement',
          name: '批量上传进度',
          component: faceTaskManagement
        },
        {
          path: '/userManagement',
          name: '用户管理',
          component: userManagement
        },
        {
          path: '/deviceVersionManagement',
          name: '设备版本管理',
          component: deviceVersionManagement
        },
        {
          path: '/deviceTypeManagement',
          name: '设备类型维护',
          component: deviceTypeManagement
        },
        {
          path: '/deviceManagement',
          name: '设备信息维护',
          component: deviceManagement
        },
        {
          path: '/deviceStateManagement',
          name: '设备状态维护',
          component: deviceStateManagement
        },
        {
          path: '/deviceAttrManagement',
          name: '设备属性维护',
          component: deviceAttrManagement
        },
        {
          path: '/deviceAttrValManagement',
          name: '设备属性值维护',
          component: deviceAttrValManagement
        },
        {
          path: '/deviceRestartManagement',
          name: '设备重启维护',
          component: deviceRestartManagement
        },
        {
          path: '/deviceUpdateManagement',
          name: '设备升级维护',
          component: deviceUpdateManagement
        },
        {
          path: '/recordManagement',
          name: '识别记录',
          component: recordManagement
        },
        {
          path: '/unidentRecordManagement',
          name: '未识别记录',
          component: unidentRecordManagement
        },
        {
          path: '/blackRecordManagement',
          name: '黑名单识别记录',
          component: blackRecordManagement
        },
        {
          path: '/visitorRecordManagement',
          name: '访客识别记录',
          component: visitorRecordManagement
        },
        {
          path: '/faceDetect',
          name: '人脸检测',
          component: faceDetect
        },
        {
          path: '/lessSearch',
          name: '1:N小库检索',
          component: lessSearch
        },
        {
          path: '/searchOne',
          name: '1:1检索',
          component: searchOne
        },
        {
          path: '/regionManagement',
          name: '位置信息维护',
          component: regionManagement
        },
        {
          path: '/deviceLogManagement',
          name: '设备上下线日志',
          component: deviceLogManagement
        },
        {
          path: '/groupManagement',
          name: '考勤组管理',
          component: groupManagement
        },
        {
          path: '/ruleManagement',
          name: '考勤规则管理',
          component: ruleManagement
        },
        {
          path: '/attendanceRecordManagement',
          name: '考勤记录管理',
          component: attendanceRecordManagement
        },
        {
          path: '/faceServiceSwitch',
          name: '人脸服务开关管理',
          component: faceServiceSwitch
        },
        {
          path:'/localFaceCardRecord',
          name: '进出记录',
          component: localFaceCardRecord
        },
        {
          path:'/localCardRecord',
          name: '刷卡刷证记录',
          component: localCardRecord
        },
        {
          path:'/newsManagement',
          name: '广告管理',
          component: newsmanagement
        },
        {
          path:'/sysConfig',
          name: '系统参数配置',
          component: sysParameterConfig
        },
        {
          path:'/outSysConfig',
          name: '推送配置',
          component: outSysConfig
        },
        {
          path:'/videoManagement',
          name: '录像回放',
          component: videoManagement
        }
      ]
    },
    {
      path:'/viewData',
      name: '进出显示',
      component: viewData
    },
    {
      path:'/padScreenData',
      name: 'pad实时显示',
      component: padScreenData
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js